module.exports = __webpack_public_path__ + "img/userIcon.86d0b731.svg";